module.exports = __webpack_public_path__ + "img/8.0b60a9ce.jpg";